/** @jsx jsx */
import { Box, Container, Flex, Grid, Pagination } from "@eworkit/iris";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { MetaTags } from "@/components/MetaTags";
import { ListViewHeader } from "@/components/views";
import { getBaseURL } from "@/core/url";
import { useNewsListQuery } from "@/data/public-profiles";
import { NewsWidgetCard } from "@/views/Clients/News/NewsWidgetCard";
import { useLandingPageMetaImgSrc } from "@/views/Landing/utils/useLandingPageMetaImgSrc";
import { router } from "@/views/router";

interface NewsListViewProps {
  isPublic?: boolean;
}

export const NewsListView: FC<NewsListViewProps> = ({ isPublic }) => {
  const { t } = useTranslation(["public"]);

  const { data, setPage, setSize } = useNewsListQuery();

  const baseRoute = isPublic ? "public-news" : "news";

  const metaImgSrc = useLandingPageMetaImgSrc();

  return (
    <React.Fragment>
      <MetaTags
        title={t("META.FIND_JOBS.TITLE")}
        description={t("META.FIND_JOBS.DESCRIPTION")}
        ogImage={`${getBaseURL()}${metaImgSrc}`}
        ogImageAlt={t("META.FIND_JOBS.IMAGE_DESCRIPTION")}
      />

      <Flex flexDirection="column" backgroundColor={isPublic ? "n0" : undefined}>
        <ListViewHeader header={t("NEWS_PAGE.TITLE")} />

        <Container>
          <Box px={[null, null, null, "sm"]} py={["md"]}>
            <Grid columns={["1fr", null, null, "1fr 1fr"]}>
              {data.content.map(n => (
                <NewsWidgetCard
                  key={n.id}
                  linkTo={router.get(`${baseRoute}.news-detail`, { newsId: n.id }).path}
                  lineClamp={2}
                  news={n}
                />
              ))}
            </Grid>
          </Box>
        </Container>
        <Container>
          <Box px={[null, null, null, "sm"]} py={["md"]}>
            <Pagination
              pagesCount={data.totalPages}
              activeIndex={data.number}
              onChangeIndex={setPage}
              pageSize={data.size}
              onChangePageSize={setSize}
              resultsLabel={t("public:COMPONENTS.PAGINATION.RESULTS")}
              showPageSizeSelect={false}
            />
          </Box>
        </Container>
      </Flex>
    </React.Fragment>
  );
};
